import React, { Component } from 'react';
import { connect } from 'react-redux';
import Underscore from 'underscore';
import DATES from '../../utils/formattedDates';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import GLOBAL_FILTER_CONTROLLER from '../../controllers/globalFilter';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import GlobalFilterPanel, {FILTER_PERIOD_GROUP} from '../filter/GlobalFilterPanel';
import SingleVATcodeSelector from '../selectors/vatCode/SingleVATCodeSelector';

const log = new Logger('VATCODE_SIMULATOR_FILTER', LOG_LEVELS.DEBUG);

let today = DATES.getTodayFormatted('yyyy-mm-dd');

export class VATCodeSimulatorFilter extends Component {

  constructor(props) {
    super(props);
    this.state = { 
      vatCodesArray: [],
      selection: {
      isGenericCode: false,
      date: today,      
      vatCode: ''
    }};
    this.handleChangeVATCode = this.handleChangeVATCode.bind(this);
    this.handleChangeVATCodeInput = this.handleChangeVATCodeInput.bind(this);
    this.handleChangeIsGenericCheckbox = this.handleChangeIsGenericCheckbox.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleCompanyChange = this.handleCompanyChange.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
  }

  onSearchClick(selection) {
    log.debug('onSearchClick(): state.selection: ', this.state.selection);
    log.debug('onSearchClick(): selection: ', selection);
    let combinedSelection = Object.assign({}, this.state.selection, selection);
    log.debug('onSearchClick(): combinedSelection: ', combinedSelection);
    this.props.onSearchClick(combinedSelection);
  }

  handleChangeIsGenericCheckbox() {
    let selection = Object.assign({}, this.state.selection);
    selection.isGenericCode = !selection.isGenericCode;
    selection.vatCode = '';
    this.setState({ selection: selection});
  }

  handleChangeVATCodeInput(event) {
    log.debug('handleChangeVATCodeInput(%s): %s, ', 'vatCode', event.target.value);
    let selection = Object.assign({}, this.state.selection);
    selection.vatCode = event.target.value;
    this.setState({ selection: selection});
  }

  handleChangeVATCode(keyValuePairs) {
    let value = '',i ;
    for(i in keyValuePairs) { value = keyValuePairs[i]; }
    log.debug('handleChangeVATCode(%s): %s, ', 'vatCode',value);
    let selection = Object.assign({}, this.state.selection);
    selection.vatCode = value;
    this.setState({ selection: selection});
  }

  handleDateChange(event){
    let selection = Object.assign({}, this.state.selection);
    selection.date = event.date || today;
    this.setState({ selection: selection});
  }

  getVatCodes(userCode, companyVatCodes=[]) {
     //Get company code from company id
    var companySelected = this.props.companies.find(c => c.id === Number(userCode));
    if(companySelected === undefined)
      return;
    let filteredCompanyVATCodes = companyVatCodes.filter(vatCode => vatCode.userCode === companySelected.code);
    log.debug('getVatCodes(%s): %s, ', 'filteredCompanyVATCodes', filteredCompanyVATCodes);
    let vatCodesArrayLocalNonUnique = Underscore.map(filteredCompanyVATCodes,function(item){ return item.vatCode;});
    return Underscore.uniq(vatCodesArrayLocalNonUnique);
  }

  handleCompanyChange(keyValuePairs) {
    let value = '',i;
    for(i in keyValuePairs) { value = keyValuePairs[i];}
    log.debug('handleCompanyChange(%s): %s, ', 'companyVatCodes', this.props.companyVatCodes);
    log.debug('handleCompanyChange(%s): %s, ', 'value', value);
    //This method gets call on change of company as well date
      //Check if company change, then get vat codes for selected company
    if(i === 'companyId') {
        let vatCodesArrayLocal = this.getVatCodes(value, this.props.companyVatCodes);
        let selection = Object.assign({}, this.state.selection);
        //Always reset vat code on company change
        selection.vatCode = '';
        this.setState({selection: selection, vatCodesArray: vatCodesArrayLocal});
    }
    else
    {
        let selection = Object.assign({}, this.state.selection);
        this.setState({selection: selection});
    }
  }

  componentDidUpdate(prevProps) {
    if(this.props.companyVatCodes !== prevProps.companyVatCodes) {
      let companyVatCodes = this.props.companyVatCodes || [];
      let globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();
      if(Underscore.isEmpty(globalFilterSelection) || Underscore.isEmpty(globalFilterSelection.companyId+'')) {
        return;
      }
      let vatCodesArrayLocal = this.getVatCodes(globalFilterSelection.companyId, companyVatCodes);
      let selection = Object.assign({}, this.state.selection);
      //Always reset vat code on company change
      selection.vatCode = '';      
      this.setState({selection: selection, vatCodesArray: vatCodesArrayLocal});
    }
  }
  

  render() {
    const {selection={}} = this.state;
    let vatCodeSelector = !selection.isGenericCode ? 'visible' : 'invisible';
    let vatCodeFreeText = selection.isGenericCode ? 'visible' : 'invisible';
    const globalFilterSetting ={
      hideElements: {
        countryCode: true,
        month: true,
        year: true,
        startDate: true,
        endDate: true,
        returnType: true,
        returnStatus: true
      },
      onFieldChange: this.handleCompanyChange,
      filterPeriodGroup: FILTER_PERIOD_GROUP.SIMPLE_DATE,
      onSearchClick: this.onSearchClick    
    };
    return (
      <s-box name="filter-panel" data-test="component-vat-code-simulator-filter">
        <GlobalFilterPanel {...globalFilterSetting}>
          <fieldset>
            <label><LanguageStringResolver string='vatCodeSimulatorFilter_VATCode'/></label>
            <span className={vatCodeSelector}>
              <SingleVATcodeSelector
                fieldName={"vatCode"}
                selectionHandler={this.handleChangeVATCode}
                selectedVATCodeId={selection.vatCode || ''}
                VATCodeList={this.state.vatCodesArray || []}
              />
            </span>
            <span className={vatCodeFreeText}>
              <input
                data-test="input-custom-vat-code"
                value={selection.vatCode  || ''}
                onChange={this.handleChangeVATCodeInput}/>
            </span>
          </fieldset>
          <fieldset>
            <legend><LanguageStringResolver string='vatCodeSimulatorFilter_GenericCheckbox'/></legend>
            <span className="clear"></span>
            <input
              type="checkbox"
              name="isGeneric"
              data-test="set-generic-vat-code"
              checked={selection.isGenericCode}
              onChange={this.handleChangeIsGenericCheckbox}
              className="checkbox"
            />
            <label className="checkbox"><LanguageStringResolver string='vatCodeSimulatorFilter_GenericCheckbox_true'/></label>
          </fieldset>
        </GlobalFilterPanel>
        <div className="clear"></div>
      </s-box>
    );
  }
}

function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);    
    return {
        languages: state.languages,
        companyVatCodes : state.vatCodeSimulator && state.vatCodeSimulator.companyVatCodes,
        companies: (state.companies && state.companies.data ) || []
    };
}


VATCodeSimulatorFilter.defaultProps = {
  onSearchClick: () => {}
}

// Wrap the component to inject state into it
export default connect(mapStateToProps)(VATCodeSimulatorFilter);
